var CartUpsellTheme = {
    typography: {
        h1: {
            headerFont: 'SANS_SERIF',
            headerSize: {
                mobile: '16px',
                tablet: '16px',
                desktop: '16px'
            },
            headerLetterSpacing: {
                mobile: '.01em',
                tablet: '.01em',
                desktop: '.01em'
            },
            headerLineHeight: {
                mobile: '1.15',
                tablet: '1.15',
                desktop: '1.15'
            },
            headerSpaceAfter: {
                mobile: '4px',
                tablet: '4px',
                desktop: '4px'
            }
        },
        h2: {
            headerFont: 'SANS_SERIF',
            headerSize: {
                mobile: '16px',
                tablet: '16px',
                desktop: '16px'
            },
            headerLetterSpacing: {
                mobile: '.01em',
                tablet: '.01em',
                desktop: '.01em'
            },
            headerLineHeight: {
                mobile: '1.15',
                tablet: '1.15',
                desktop: '1.15'
            },
            headerSpaceAfter: {
                mobile: '4px',
                tablet: '4px',
                desktop: '4px'
            }
        },
        h3: {
            headerFont: 'SANS_SERIF',
            headerSize: {
                mobile: '16px',
                tablet: '16px',
                desktop: '16px'
            },
            headerLetterSpacing: {
                mobile: '.01em',
                tablet: '.01em',
                desktop: '.01em'
            },
            headerLineHeight: {
                mobile: '1.15',
                tablet: '1.15',
                desktop: '1.15'
            },
            headerSpaceAfter: {
                mobile: '4px',
                tablet: '4px',
                desktop: '4px'
            }
        },
        h4: {
            headerFont: 'SANS_SERIF',
            headerSize: {
                mobile: '16px',
                tablet: '16px',
                desktop: '16px'
            },
            headerLetterSpacing: {
                mobile: '.01em',
                tablet: '.01em',
                desktop: '.01em'
            },
            headerLineHeight: {
                mobile: '1.15',
                tablet: '1.15',
                desktop: '1.15'
            },
            headerSpaceAfter: {
                mobile: '4px',
                tablet: '4px',
                desktop: '4px'
            }
        },
        h5: {
            headerFont: 'SANS_SERIF',
            headerSize: {
                mobile: '16px',
                tablet: '16px',
                desktop: '16px'
            },
            headerLetterSpacing: {
                mobile: '.01em',
                tablet: '.01em',
                desktop: '.01em'
            },
            headerLineHeight: {
                mobile: '1.15',
                tablet: '1.15',
                desktop: '1.15'
            },
            headerSpaceAfter: {
                mobile: '4px',
                tablet: '4px',
                desktop: '4px'
            }
        },
        h6: {
            headerFont: 'SANS_SERIF',
            headerSize: {
                mobile: '16px',
                tablet: '16px',
                desktop: '16px'
            },
            headerLetterSpacing: {
                mobile: '.01em',
                tablet: '.01em',
                desktop: '.01em'
            },
            headerLineHeight: {
                mobile: '1.15',
                tablet: '1.15',
                desktop: '1.15'
            },
            headerSpaceAfter: {
                mobile: '4px',
                tablet: '4px',
                desktop: '4px'
            }
        },
        eyebrow: {
            eyebrowSize: {
                mobile: '12px',
                tablet: '12px',
                desktop: '12px'
            },
            eyebrowLetterSpacing: {
                mobile: '0em',
                tablet: '0em',
                desktop: '0em'
            },
            eyebrowLineHeight: {
                mobile: '1',
                tablet: '1',
                desktop: '1'
            },
            eyebrowSpaceAfter: {
                mobile: '4px',
                tablet: '4px',
                desktop: '4px'
            }
        },
        body: {
            bodyFont: 'SANS_SERIF',
            bodySize: {
                mobile: '14px',
                tablet: '14px',
                desktop: '14px'
            },
            bodyLetterSpacing: {
                mobile: '.02em',
                tablet: '.02em',
                desktop: '.02em'
            },
            bodyLineHeight: {
                mobile: '1.5',
                tablet: '1.5',
                desktop: '1.5'
            },
            bodySpaceAfter: {
                mobile: '24px',
                tablet: '24px',
                desktop: '24px'
            }
        }
    }
};
export default CartUpsellTheme;
